import { Link } from "react-router-dom";
import { AlertTriangle, CalendarPlus } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const fmt = (iso) => {
  const d = new Date(iso);
  return `${d.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "short" })} at ${d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}`;
};

// Non-dismissible: clears only when a new assessment is booked or the coach waives it.
export function AssessmentRiskBanner({ narrow = false }) {
  const { user } = useAuth();
  const risk = user?.assessment_risk;
  if (!risk || user?.assessment_status === "completed") return null;
  const list = risk.bookings || [];
  return (
    <div className={`mb-6 lg:mt-14 border-2 border-[#FF9F1C] bg-[#FF9F1C]/10 p-5 flex items-start gap-3 ${narrow ? "max-w-[860px] mx-auto" : ""}`} data-testid="assessment-risk-banner" role="alert">
      <AlertTriangle className="w-6 h-6 text-[#FF9F1C] shrink-0" />
      <div className="flex-1 min-w-0 space-y-2">
        <div className="font-bold text-[#FF9F1C] text-base">Your assessment has been cancelled</div>
        <div className="text-sm text-[#E5E5E5]">
          {list.length
            ? `${list.length === 1 ? "This upcoming session relies" : "These upcoming sessions rely"} on a completed assessment and may be cancelled by your coach:`
            : "Book a new assessment so you can keep booking sessions."}
        </div>
        {list.length > 0 && (
          <ul className="text-sm space-y-1" data-testid="assessment-risk-list">
            {list.map((b) => (
              <li key={b.booking_id} data-testid={`assessment-risk-item-${b.booking_id}`}>
                <Link to={`/session/${b.booking_id}`} className="font-semibold hover:text-[#CCFF00]">{b.title}</Link>
                <span className="text-[#A3A3A3]"> — {b.when || fmt(b.start)}</span>
              </li>
            ))}
          </ul>
        )}
        <Link to="/offerings?assessment_only=true" data-testid="assessment-risk-book"
          className="mt-1 min-h-[44px] px-5 py-2.5 text-xs uppercase tracking-wider font-bold bg-[#CCFF00] text-black inline-flex items-center gap-2 active:scale-95 transition-transform">
          <CalendarPlus className="w-4 h-4" /> Book a new assessment
        </Link>
      </div>
    </div>
  );
}
